// extracted by mini-css-extract-plugin
export var content = "_404-module--content--16992";
export var link = "_404-module--link--df849";
export var linkBlocks = "_404-module--linkBlocks--4c645";
export var subtitle = "_404-module--subtitle--12df5";
export var title = "_404-module--title--33977";
export var wrapper = "_404-module--wrapper--216b8";